import { Checkbox } from "@/components/ui/checkbox";
import { PurchaseTermsDialog } from "./PurchaseTermsDialog";

interface PurchaseTermsCheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  className?: string;
}

/**
 * Mandatory acceptance checkbox shown above every checkout CTA.
 * The bracketed link opens the full <PurchaseTermsDialog>.
 */
export function PurchaseTermsCheckbox({ checked, onCheckedChange, className }: PurchaseTermsCheckboxProps) {
  return (
    <label
      className={
        "flex items-start gap-2.5 rounded-md border border-border bg-muted/30 p-3 text-xs leading-relaxed text-foreground/80 cursor-pointer " +
        (className ?? "")
      }
    >
      <Checkbox
        checked={checked}
        onCheckedChange={(v) => onCheckedChange(v === true)}
        className="mt-0.5"
        aria-required="true"
      />
      <span>
        Li e concordo com as condições de compra, acesso ao curso, prazo de uso, política de
        cancelamento e reembolso. Acesso liberado após a confirmação do pagamento.{" "}
        <PurchaseTermsDialog
          trigger={
            <button
              type="button"
              onClick={(e) => e.preventDefault()}
              className="font-medium text-primary underline-offset-2 hover:underline"
            >
              Ler Termos de Compra, Acesso e Reembolso
            </button>
          }
        />
      </span>
    </label>
  );
}
